import React, { createContext, useContext, useState, useEffect } from "react";

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [scrollControlledNavbar, setScrollControlledNavbar] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    if (!scrollControlledNavbar) return; // If no scroll control needed, do nothing

    const handleScroll = () => {
      if (window.scrollY < lastScrollY) {
        setShowNavbar(true); // Scrolling up
      } else {
        setShowNavbar(false); // Scrolling down
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollControlledNavbar, lastScrollY]);

  return (
    <NavbarContext.Provider
      value={{
        scrollControlledNavbar,
        setScrollControlledNavbar,
        showNavbar, // ✨ now exported
      }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbarContext = () => useContext(NavbarContext);
